import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  result: undefined,
  error: undefined,
};

const change = (store, data) => {
  store.setState((state) => {
    state.app.usuarios.info.data = data;
  });
};

const info = async (store, id, params = {}) => {
  store.setState((state) => {
    state.app.usuarios.info.busy = true;
  });

  try {
    const response = await Http.get(`api/usuarios/${id}`, { params });

    const { data } = response;

    let newData = data;

    if (!!data.sucursales && data.sucursales.length > 0) {
      newData = {
        ...data,
        sucursales: data.sucursales.map((item) => {
          return {
            label: item,
            value: item,
          };
        }),
      };
    }

    store.setState((state) => {
      state.app.usuarios.info.data = newData;
      state.app.usuarios.info.busy = false;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.usuarios.info.error = error.data || error;
      state.app.usuarios.info.busy = false;
    });
  }
};

const UsuarioInfoStore = {
  state: () => initialState,
  actions: {
    change,
    info,
  },
};

export default UsuarioInfoStore;
